import LocalizedStrings from "react-localization";
import EngStrings from './locale.en';
import TradChnStrings from './locale.tc';
import SimpChnStrings from './locale.sc';

import {CoreStrings} from '../../core/utilities/coreLocalization';

export default new LocalizedStrings({
    Eng: {...CoreStrings.Eng, ...EngStrings.Eng},
    TradChn: {...CoreStrings.TradChn, ...TradChnStrings.TradChn},
    SimpChn: {...CoreStrings.SimpChn, ...SimpChnStrings.SimpChn},
});